function ClockGraphic({}) {
  return (
    <svg
      width='100%'
      height='100%'
      viewBox='0 0 183 178'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M83.8009 171.55C127.963 171.55 163.937 145.53 165.603 113H2.00098C3.66748 145.533 39.6589 171.55 83.8032 171.55H83.8009Z'
        fill='#3A3A3A'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.43953 103C5.33512 103 6.87809 101.429 6.87809 99.5C6.87809 97.5709 5.33737 96 3.43953 96C1.5417 96 0.000976562 97.5686 0.000976562 99.5C0.000976562 101.431 1.54395 103 3.43953 103Z'
        fill='#E5E5EA'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M176.671 98.8255C179.797 98.8255 182.341 96.1756 182.341 92.9127C182.341 89.6499 179.801 87 176.671 87C173.542 87 171.001 89.6538 171.001 92.9127C171.001 96.1717 173.545 98.8255 176.671 98.8255Z'
        fill='#3A3A3A'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M32.8643 177.136C35.5182 177.136 37.7213 174.839 37.7213 172.068C37.7213 169.297 35.5182 167 32.8643 167C30.2104 167 28.001 169.297 28.001 172.068C28.001 174.839 30.2041 177.136 32.8643 177.136Z'
        fill='#8474D9'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M159.44 158C161.335 158 162.878 156.429 162.878 154.5C162.878 152.571 161.337 151 159.44 151C157.542 151 156.001 152.569 156.001 154.5C156.001 156.431 157.542 158 159.44 158Z'
        fill='#FFBB53'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M146.732 149.586C131.722 162.992 109.11 171.544 83.8046 171.544C58.4995 171.544 35.8872 162.992 20.8775 149.586C11.2019 139.735 22.6495 124.777 34.8945 132.119C52.7925 142.855 95.926 168.891 146.734 149.586H146.732Z'
        fill='#595959'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M46.0298 20.4468C48.297 20.4468 50.1012 18.5666 50.1012 16.2035C50.1012 13.8405 48.297 12 46.0298 12C43.7626 12 42.001 13.8802 42.001 16.2035C42.001 18.5268 43.8052 20.4468 46.0298 20.4468Z'
        fill='#8474D9'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M168.044 57.1908C170.699 57.1908 172.904 54.9361 172.904 52.0955C172.904 49.2549 170.699 47.0547 168.044 47.0547C165.388 47.0547 163.184 49.3094 163.184 52.0955C163.184 54.8816 165.388 57.1908 168.044 57.1908Z'
        fill='#E5E5EA'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.86112 64.1361C7.51673 64.1361 9.72127 61.8392 9.72127 59.0681C9.72127 56.2969 7.51673 54 4.86112 54C2.20551 54 0.000976562 56.2969 0.000976562 59.0681C0.000976562 61.8392 2.20551 64.1361 4.86112 64.1361Z'
        fill='#3A3A3A'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M109.671 11.8255C112.797 11.8255 115.341 9.17563 115.341 5.91275C115.341 2.64986 112.801 0 109.671 0C106.542 0 104.001 2.64986 104.001 5.91275C104.001 9.17563 106.542 11.8255 109.671 11.8255Z'
        fill='#FFBB53'
      />
      <path
        d='M36.7181 113.127C47.2126 121.666 51.0621 134.313 51.0621 134.313C51.0621 134.313 38.4976 132.377 28.0031 123.837C17.5085 115.298 13.058 103.389 13.058 103.389C13.058 103.389 26.2235 104.587 36.7181 113.127Z'
        fill='#8578C8'
      />
      <path
        d='M41.1201 106.718C48.3396 118.161 47.9504 131.375 47.9504 131.375C47.9504 131.375 36.6616 125.529 29.4421 114.086C22.2227 102.643 21.8064 89.9373 21.8064 89.9373C21.8064 89.9373 33.9007 95.2756 41.1201 106.718Z'
        fill='#A092EC'
      />
      <path
        d='M145.616 112.175C134.764 128.799 116.899 136.355 116.899 136.355C116.899 136.355 117.798 117.724 128.65 101.1C139.502 84.4762 156.197 76.1556 156.197 76.1556C156.197 76.1556 156.468 95.5513 145.616 112.175Z'
        fill='#A092EC'
      />
      <line
        x1='80.3027'
        y1='125.486'
        x2='107.198'
        y2='125.486'
        stroke='#606060'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <line
        x1='80.3027'
        y1='133.984'
        x2='107.198'
        y2='133.984'
        stroke='#606060'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M85.5 143.999C117.169 143.999 143 118.169 143 86.4987C143 54.8283 117.169 29 85.5 29C53.831 29 28 54.8297 28 86.5C28 118.17 53.8297 144 85.5 144V143.999Z'
        fill='#8474D9'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M85.4848 132C110.558 132 131 111.559 131 86.4855C131 61.4121 110.558 41 85.4848 41C60.4118 41 40 61.4412 40 86.4855C40 111.53 60.4409 132 85.4848 132Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M84.0202 44C85.1292 44 86 44.7156 86 45.5867V56.4133C86 57.2844 85.1292 58 84.0202 58C82.9111 58 82 57.2844 82 56.4133V45.5867C82 44.7156 82.9111 44 84.0202 44Z'
        fill='#B4B4B4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M84.0202 115C85.1292 115 86 115.613 86 116.36V125.64C86 126.387 85.1292 127 84.0202 127C82.9111 127 82 126.387 82 125.64V116.36C82 115.613 82.9111 115 84.0202 115Z'
        fill='#B4B4B4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M42 85.5151C42 84.6833 42.7156 84 43.5867 84H54.4133C55.2844 84 56 84.6833 56 85.5151C56 86.3469 55.2844 87 54.4133 87H43.5867C42.7156 87 42 86.3469 42 85.5151Z'
        fill='#B4B4B4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M113 85.5151C113 84.6833 113.665 84 114.473 84H124.527C125.335 84 126 84.6833 126 85.5151C126 86.3469 125.335 87 124.527 87H114.473C113.665 87 113 86.3469 113 85.5151Z'
        fill='#B4B4B4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M120.857 68.9323V68.8996C120.518 68.0982 119.641 67.7777 118.934 68.1621L115.794 69.8939C115.087 70.2783 114.804 71.2726 115.143 72.074C115.482 72.8754 116.359 73.2286 117.066 72.8442L120.206 71.1123C120.913 70.6953 121.196 69.7336 120.857 68.9323Z'
        fill='#B4B4B4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M55.846 100.916C55.5075 100.113 54.6607 99.7587 53.9263 100.177L50.8202 101.913C50.0858 102.298 49.8036 103.262 50.142 104.098C50.4805 104.902 51.356 105.223 52.0617 104.838L55.1953 103.101C55.9009 102.716 56.2119 101.719 55.8447 100.916H55.846Z'
        fill='#B4B4B4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M106.11 53.22C105.24 52.7857 104.119 53.0176 103.577 53.7119L101.259 56.7533C100.752 57.4489 101.006 58.3752 101.874 58.78C102.744 59.2143 103.902 58.9824 104.408 58.2881L106.725 55.2467C107.268 54.5511 106.978 53.6248 106.11 53.22Z'
        fill='#B4B4B4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M69.111 114.207C68.2439 113.802 67.1261 114.004 66.5848 114.699L64.2742 117.772C63.7329 118.468 64.0219 119.365 64.8874 119.8C65.7545 120.206 66.909 119.974 67.4152 119.278L69.7258 116.234C70.2671 115.538 69.9781 114.64 69.1126 114.206L69.111 114.207Z'
        fill='#B4B4B4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M50.1433 68.9323V68.8996C50.4817 68.0982 51.357 67.7777 52.0625 68.1621L55.1954 69.8939C55.901 70.2783 56.2119 71.2726 55.8448 72.074C55.5064 72.8754 54.6598 73.2286 53.9255 72.8442L50.82 71.1123C50.0858 70.6953 49.8036 69.7336 50.142 68.9323H50.1433Z'
        fill='#B4B4B4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M115.155 100.916C115.494 100.113 116.369 99.7587 117.075 100.177L120.208 101.913C120.914 102.298 121.196 103.262 120.857 104.098C120.519 104.902 119.643 105.223 118.938 104.838L115.805 103.101C115.099 102.716 114.788 101.719 115.155 100.916Z'
        fill='#B4B4B4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M64.886 53.22C65.7533 52.7857 66.9082 53.0176 67.4145 53.7119L69.7257 56.7533C70.2672 57.4489 69.9781 58.3752 69.1124 58.78C68.2451 59.2143 67.127 58.9824 66.5855 58.2881L64.2743 55.2467C63.7328 54.5511 64.0219 53.6248 64.8876 53.22H64.886Z'
        fill='#B4B4B4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M101.874 114.207C102.744 113.802 103.902 114.004 104.408 114.699L106.725 117.772C107.268 118.468 106.978 119.365 106.11 119.8C105.24 120.206 104.119 119.974 103.577 119.278L101.259 116.234C100.752 115.538 101.006 114.64 101.874 114.206V114.207Z'
        fill='#B4B4B4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M70.9723 61.3088C71.9155 60.6911 73.1445 61.0314 73.716 62.0509L87.7216 87.7557C88.2931 88.7752 87.9504 90.1036 87.0072 90.6912C86.064 91.3089 84.8628 90.9686 84.2913 89.9491L70.2857 64.2443C69.7142 63.2248 70.029 61.8964 70.9723 61.3088Z'
        fill='#8474D9'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M105.78 79.0835C106.296 80.024 105.872 81.1846 104.838 81.6542L89.0741 88.7877C88.0113 89.2855 86.7349 88.8709 86.219 87.9304C85.703 86.99 86.1276 85.8294 87.1904 85.3598L102.955 78.1993C103.988 77.7297 105.263 78.1161 105.779 79.0835H105.78Z'
        fill='#8474D9'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M85.5 93C87.9796 93 90 90.9804 90 88.5C90 86.0196 87.9804 84 85.5 84C83.0196 84 81 86.0196 81 88.5C81 90.9804 83.0196 93 85.5 93Z'
        fill='#8474D9'
      />
    </svg>
  );
}

export default ClockGraphic;
